import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as baselineActions } from '../../actions/baselineActions';
import * as types from '../../constants/actionTypes';
import Drawer from '../Common/Drawer/Drawer';
import PushdownPreviewResults from './PushdownPreviewResults';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../Common/Notification';
import DatePicker from '../Common/DatePicker/DatePicker';
import { DATE_FORMAT } from '../../constants/constants';
import Moment from 'moment';

export class PushdownPreviewDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            results: null,
            isFetching: false,
            openingDate: Moment().format(DATE_FORMAT)
        }
    }

    onCancel = () => {
        this.props.onComplete();
    }

    onGetResults = async () => {
        try {
            this.setState({ isFetching: true });
            const result = await this.props.baselineActions.previewPushdown(this.props.baselineId, Moment.utc(this.state.openingDate, DATE_FORMAT));
            const payload = result.payload;
            if (result.type === types.PREVIEW_BASELINE_PUSHDOWN_SUCCESS) {
                this.setState({ results: payload });
            } else if (result.type === types.PREVIEW_BASELINE_PUSHDOWN_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isFetching: false });
        }
    }

    onChangeOpeningDate = (dateString) => {
        this.setState({ openingDate: dateString });
    }

    render() {

        const dateTypeString = (this.props.isProjectWidgetActive) ? "Zero Date" : "Opening Date";

        return (
            <Drawer isWide={false} title='Pushdown Preview'
                onCancelClick={this.onCancel}
            >

                <div className="row pushdown-preview">
                    <div className="col-8">
                        <DatePicker showIcon name="openingDate" value={this.state.openingDate} label={dateTypeString} onChange={this.onChangeOpeningDate} />
                    </div>
                    <div className="col-3">
                        <button id="preview" type="button" className="btn btn-secondary" onClick={this.onGetResults}>Preview</button>
                    </div>
                </div>

                <LoadingIndicator isLoading={this.state.isFetching}>
                    <PushdownPreviewResults
                        results={this.state.results}
                        isProjectWidgetActive={this.props.isProjectWidgetActive}
                    />
                </LoadingIndicator>
            </Drawer>
        )
    }
}

PushdownPreviewDrawer.propTypes = {
    baselineActions: PropTypes.object.isRequired,
    baselineId: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired,
    isProjectWidgetActive: PropTypes.bool.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        baselineActions: bindActionCreators(baselineActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(PushdownPreviewDrawer);
